import { createContext } from 'react';

const FollowsContext = createContext();

export default FollowsContext;